import * as Types from '@trello/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"UpdateCardName"}}
export type UpdateCardNameMutationVariables = Types.Exact<{
  idCard: Types.Scalars['ID'];
  name: Types.Scalars['String'];
  traceId: Types.Scalars['String'];
}>;


export type UpdateCardNameMutation = (
  { __typename: 'Mutation' }
  & { updateCardName?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id' | 'name'>
  )> }
);


export const UpdateCardNameDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCardName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCardName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idCard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idCard"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]};
export type UpdateCardNameMutationFn = Apollo.MutationFunction<UpdateCardNameMutation, UpdateCardNameMutationVariables>;

/**
 * __useUpdateCardNameMutation__
 *
 * To run a mutation, you first call `useUpdateCardNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCardNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardNameMutation, { data, loading, error }] = useUpdateCardNameMutation({
 *   variables: {
 *      idCard: // value for 'idCard'
 *      name: // value for 'name'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useUpdateCardNameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCardNameMutation, UpdateCardNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCardNameMutation, UpdateCardNameMutationVariables>(UpdateCardNameDocument, options);
      }
export type UpdateCardNameMutationHookResult = ReturnType<typeof useUpdateCardNameMutation>;
export type UpdateCardNameMutationResult = Apollo.MutationResult<UpdateCardNameMutation>;
export type UpdateCardNameMutationOptions = Apollo.BaseMutationOptions<UpdateCardNameMutation, UpdateCardNameMutationVariables>;